// Same-origin runtime config validation (`/hybrid-config.json`). Pure: no DOM, no credentials.

export function sanitizeConfig(c) {
  const out = {};
  if (!c || typeof c !== 'object') return out;
  if (typeof c.apiBase === 'string' && /^\/[A-Za-z0-9/_-]{1,64}$/.test(c.apiBase)) out.apiBase = c.apiBase;
  if (c.brandHosts && typeof c.brandHosts === 'object') out.brandHosts = Object.fromEntries(Object.entries(c.brandHosts).filter(([k, v]) => /^[a-z-]{1,32}$/.test(k) && typeof v === 'string' && /^https:\/\/[a-z0-9.-]+(:\d+)?\/?$/i.test(v)));
  if (Array.isArray(c.iceServers)) out.iceServers = c.iceServers.slice(0, 4).filter((s) => s && [].concat(s.urls).every((u) => typeof u === 'string' && /^(stun|turns?):[^\s]{1,200}$/.test(u))).map((s) => ({ urls: s.urls, ...(typeof s.username === 'string' ? { username: s.username } : {}), ...(typeof s.credential === 'string' ? { credential: s.credential } : {}) }));
  return out;
}
